import { type IProductSpecIterator, type IProductSpecItem } from "../..";
import { OldProductSpecItem } from "./OldProductSpecItem";

function getParent(el: Element | null | undefined, className: string) {
    if (el == null) {
        return undefined;
    }
    if (el.classList.contains(className)) {
        return el;
    }
    return getParent(el.parentElement, className);
}

export class OldProductSpecIterator implements IProductSpecIterator {
    *getItems(): Generator<IProductSpecItem, any, any> {
        const countDownTimers = Array.from(
            document.querySelectorAll(".countdownTimer")
        );
        for (const timerElement of countDownTimers) {
            const specsContainer = getParent(timerElement, "specsToUpdate");
            if (specsContainer == null) continue;

            const timer = $(timerElement);
            const triggerForced = timer.data("forceTrigger");
            timer.removeData("forceTrigger");

            yield new OldProductSpecItem({
                auctionSocketId: parseInt(
                    specsContainer.getAttribute("data-item-id") ?? ""
                ),
                forced: triggerForced,
                timer: timer,
                specsContainer: specsContainer,
            });
        }
    }
}
